/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import logoBlack from "assets/img/logo/logo-black.png";
import logoWhite from "assets/img/logo/logo-white.png";

import SidebarCard from "components/sidebar/components/SidebarCard";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import routes from "routes";
import Card from "components/card";

const SidebarHorizon = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
  variant?: string;
}) => {
  const { open, onClose, variant } = props;
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        variant === "auth" ? "xl:hidden" : "xl:block"
      } ${open ? "" : "-translate-x-full"}`}
    >
      <Card
        extra={`w-[285px] ml-3 sm:mr-4 sm:my-4 h-[96.5vh] m-7 !rounded-[20px]`}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <div className="flex h-full flex-col justify-between">
            <div>
              <span
                className="absolute top-4 right-4 block cursor-pointer xl:hidden"
                onClick={onClose}
              >
                <HiX />
              </span>
              <div className={`h-[60px] flex items-center justify-center`}>
                <div className="">
                  SALEBEAT
                </div>
              </div>
              <div className="mb-7 h-px bg-gray-200 dark:bg-white/10" />
              {/* Nav item */}
              <ul className="ml-[10px] pt-1">
                <Links routes={routes.filter(route => route.menu)} />
              </ul>
            </div>
            {/* Free Horizon Card    */}
            {/* <div className="mt-[28px] mb-[150px] flex justify-center">
              <SidebarCard />
            </div> */}
          </div>
        </Scrollbars>
      </Card>
    </div>
  );
};

export default SidebarHorizon;
